/**
 * Bridge utilities: convert wagmi v2 clients to ethers v5 signer/provider.
 *
 * Required because the TypeChain-generated bridge contracts use ethers v5.
 * This follows the pattern documented at https://wagmi.sh/react/ethers-adapters
 */
import { providers } from "ethers";
import type {
  WalletClient,
  PublicClient,
  Transport,
  Chain,
  Account,
} from "viem";

export function walletClientToSigner(
  walletClient: WalletClient<Transport, Chain, Account>
): providers.JsonRpcSigner {
  const { account, transport } = walletClient;
  // Use "any" so ethers tolerates the wallet switching chains (Palm <-> Ethereum)
  // rather than throwing NETWORK_ERROR "underlying network changed" when the
  // declared network (from a momentarily-stale walletClient.chain) disagrees
  // with the chain the injected provider is actually on.
  const provider = new providers.Web3Provider(transport, "any");
  return provider.getSigner(account.address);
}

export function publicClientToProvider(
  publicClient: PublicClient
): providers.JsonRpcProvider {
  const { chain, transport } = publicClient as PublicClient & {
    transport: { url?: string };
  };
  const network = {
    chainId: chain!.id,
    name: chain!.name,
  };
  return new providers.JsonRpcProvider(transport.url, network);
}
